module.exports = __webpack_public_path__ + "img/368-cf8d17.png";